import parseDate  from "@/client/helpers/parseDate";
import dateFormat from 'date-fns/format';
import dateRU     from 'date-fns/locale/ru';

const options = { locale: dateRU };

const formatDate = ( date, format = 'dd.MM.yyyy' ) => {
  if (!date) return null;
  if (!(date instanceof Date)) date = parseDate(date);
  return dateFormat(date, format, options);
};

export default formatDate;
